import _numeral from 'numeral'

export default ({ app }, inject) => {
	inject('_numeral', _numeral)
}
